



























import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";

import Team from "@/components/MatchCard/MatchCardContent/Team.vue";
import ScorePlaceHolder from "@/components/MatchCard/MatchCardContent/ScorePlaceHolder.vue";
import TeamLineUp from '@/components/MatchCard/MatchCardContent/TeamLineUp.vue';
import Events from '@/components/MatchCard/MatchCardContent/Events.vue';

import ScorebatService from '@/services/ScorebatService';

@Component({
    components: {
        Team,
        ScorePlaceHolder,
        TeamLineUp,
        Events
    }
})
export default class MatchCard extends Vue {
    @Prop() fixture: any;

    public matchData: any = {};

    public mounted() {
        ScorebatService.getMatchData(this.fixture.s1, this.fixture.s2)
        .then((response: any) => this.matchData = response.data.response);
    }
}
